// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartFrontSide.js" company="Izenda">
// Copyright (c) 2015 Izenda, Inc.  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and  International
// Copyright Laws. Unauthorized reproduction,  reverse-engineering, and
// distribution of all or any portion of  the code contained in this file is
// strictly prohibited and may  result in severe civil and criminal penalties
// and will be  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES  ARE CONFIDENTIAL AND
// PROPRIETARY TRADE  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
// LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET  CONTROLS AS
// PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED  FILES OR ANY
// PORTION OF ITS CONTENTS SHALL AT NO TIME BE  COPIED, TRANSFERRED, SOLD,
// DISTRIBUTED, OR OTHERWISE MADE  AVAILABLE TO OTHER INDIVIDUALS WITHOUT
// EXPRESS WRITTEN CONSENT  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  ADDITIONAL
// RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * ChartFrontSide component
 */

import React, { Component } from 'react';
import { observer } from 'mobx-react';
import classnames from 'classnames';
import connect from 'share/enhancers/Izenda.Connect';

import ChartPreview from './Izenda.ChartPreview';
import ReportPartTitle from '../FieldContainers/Izenda.ReportPartTitle';
import PrintingUtils from 'share/utils/Izenda.PrintingUtils';

import { REPORT_PART_MODE, REPORT_PART_SMALL_SIZE } from 'logic/data/Izenda.ReportBodyConstants';
import localizer from 'share/localization/Izenda.Localizer';
import VerticalLayout from 'share/components/controls/Izenda.VerticalLayout';
import actions from './Izenda.ChartFrontSideActions';
import { get } from 'lodash/fp';

const ReportPartBody = observer(props => {
  const isBeingBuild = get('reportPartContent.isBeingBuild', props.reportPart);

  if (isBeingBuild) {
    return <ChartPreview {...props} />;
  } else {
    return (
      <div className="default-layout">
        <div className="chart-goes-here">
          <span>{localizer.getText('REPORTDESIGNER_PLACEHOLDER_CHART_GOES_HERE')}</span>
        </div>
      </div>
    );
  }
});

@connect(actions)
export default class ChartFrontSide extends Component {
  render() {
    const props = this.props;
    const reportPartDetails = props.reportPart || {};
    const reportPartContent = reportPartDetails.reportPartContent;
    const sizeStyle = props.style ? props.style : {};
    const {
      printingMode,
      hideTitle,
      width,
      separator,
      forExporting,
      forDashboard,
      doesBreakPage,
      embededReportPart
    } = props;
    const classes = classnames({
      'report-part-chart-front-side': true,
      'izenda-ReportPart-smallSize': width < REPORT_PART_SMALL_SIZE
    });

    if (printingMode) {
      const containerSize = {
        width: parseInt(get('width', sizeStyle)),
        height: parseInt(get('height', sizeStyle))
      };

      return (
        <div className="report-part-chart-front-side" style={PrintingUtils.getReportPartContainerStyle(props)}>
          <div className={PrintingUtils.getReportPartClassName(props)} style={sizeStyle}>
            {!hideTitle && (
              <ReportPartTitle
                mode={REPORT_PART_MODE.PREVIEW}
                reportPart={reportPartDetails}
                reportPartContent={reportPartContent}
              />
            )}
            <ReportPartBody
              reportPart={reportPartDetails}
              finishedRender={props.finishedRender}
              fulfilledData={props.fulfilledData}
              style={sizeStyle}
              key={reportPartDetails.id}
              isPreview
              printingMode
              viewMode
              separator={separator}
              forExporting={forExporting}
              doesBreakPage={!forDashboard && doesBreakPage && !embededReportPart}
              containerSize={containerSize}
              getSortValueForLinearChart={props.getSortValueForLinearChart}
              updateDrillComponent={props.updateDrillComponent}
              setDefaultIntervalForDatetime={props.setDefaultIntervalForDatetime}
              setPageSize={props.setPageSize}
              onDrilldown={props.onDrilldown}
              pointAction={props.pointAction}
            />
          </div>
        </div>
      );
    }

    return (
      <VerticalLayout {...props} className={classes}>
        <ReportPartTitle mode={REPORT_PART_MODE.PREVIEW} reportPart={reportPartDetails} />
        <ReportPartBody {...props} key={reportPartDetails.id} />
      </VerticalLayout>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartChart/Izenda.ChartFrontSide.js